type RemoteKeyEvent = Pick<KeyboardEvent, 'keyCode' | 'key' | 'code'>;

const REMOTE_KEYS = {
  back: [10009, 461, 'XF86Back', 'GoBack', 'Escape'],
  exit: [10182, 'XF86Exit'],
  enter: [13, 'Enter'],
  left: [37, 'ArrowLeft'],
  up: [38, 'ArrowUp'],
  right: [39, 'ArrowRight'],
  down: [40, 'ArrowDown'],
  space: [32, ' ', 'Space'],
  home: [36, 'Home'],
  end: [35, 'End'],
  shift: [16, 'Shift'],
  imeDone: [65376],
  imeCancel: [65385]
};

const matchesKey = (event: RemoteKeyEvent, keys: (number | string)[]) =>
  keys.includes(event.keyCode) || keys.includes(event.key) || keys.includes(event.code);

const isBackKey = (event: RemoteKeyEvent) => matchesKey(event, REMOTE_KEYS.back);
const isExitKey = (event: RemoteKeyEvent) => matchesKey(event, REMOTE_KEYS.exit);
const isEnterKey = (event: RemoteKeyEvent) => matchesKey(event, REMOTE_KEYS.enter);
const isLeftKey = (event: RemoteKeyEvent) => matchesKey(event, REMOTE_KEYS.left);
const isUpKey = (event: RemoteKeyEvent) => matchesKey(event, REMOTE_KEYS.up);
const isRightKey = (event: RemoteKeyEvent) => matchesKey(event, REMOTE_KEYS.right);
const isDownKey = (event: RemoteKeyEvent) => matchesKey(event, REMOTE_KEYS.down);
const isSpaceKey = (event: RemoteKeyEvent) => matchesKey(event, REMOTE_KEYS.space);
const isHomeKey = (event: RemoteKeyEvent) => matchesKey(event, REMOTE_KEYS.home);
const isEndKey = (event: RemoteKeyEvent) => matchesKey(event, REMOTE_KEYS.end);
const isShiftKey = (event: RemoteKeyEvent) => matchesKey(event, REMOTE_KEYS.shift);
const isImeDoneKey = (event: RemoteKeyEvent) => matchesKey(event, REMOTE_KEYS.imeDone);
const isImeCancelKey = (event: RemoteKeyEvent) => matchesKey(event, REMOTE_KEYS.imeCancel);

const registerRemoteKeys = () => {
  try {
    window.tizen?.tvinputdevice?.registerKeyBatch(['Exit']);
  } catch (e) {
    console.warn('Key registration failed:', e);
  }
};

export {
  registerRemoteKeys,
  isBackKey,
  isExitKey,
  isEnterKey,
  isLeftKey,
  isUpKey,
  isRightKey,
  isDownKey,
  isSpaceKey,
  isHomeKey,
  isEndKey,
  isShiftKey,
  isImeDoneKey,
  isImeCancelKey
};
